import { IEnvService } from '@/core/services/env/env-service'
import { type FirebaseOptions } from 'firebase/app'

export const createFirebaseConfig = (
  envService: IEnvService,
): FirebaseOptions => ({
  apiKey: envService.get('FIREBASE_API_KEY'),
  authDomain: envService.get('FIREBASE_AUTH_DOMAIN'),
  projectId: envService.get('FIREBASE_PROJECT_ID'),
  storageBucket: envService.get('FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: envService.get('FIREBASE_MESSAGING_SENDER_ID'),
  appId: envService.get('FIREBASE_APP_ID'),
  measurementId: envService.get('FIREBASE_MESSAGING_SENDER_ID'),
})
